import React from "react";
import { AuthContext } from "../contextProviders/AuthProvider";

export const useAuth = () => {
    return React.useContext(AuthContext);
}